import React from 'react';

const IcCalendarRed = () => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M7.32397 15.4556C7.32397 15.2568 7.48515 15.0956 7.68397 15.0956H8.98797C9.1868 15.0956 9.34797 15.2568 9.34797 15.4556V16.7596C9.34797 16.9585 9.1868 17.1196 8.98797 17.1196H7.68397C7.48515 17.1196 7.32397 16.9585 7.32397 16.7596V15.4556Z'
                fill='#333438'
            />
            <path
                d='M11.5482 11.5996C11.3494 11.5996 11.1882 11.7608 11.1882 11.9596V13.2636C11.1882 13.4624 11.3494 13.6236 11.5482 13.6236H12.8522C13.0511 13.6236 13.2122 13.4624 13.2122 13.2636V11.9596C13.2122 11.7608 13.0511 11.5996 12.8522 11.5996H11.5482Z'
                fill='#333438'
            />
            <path
                d='M11.1882 15.4556C11.1882 15.2568 11.3494 15.0956 11.5482 15.0956H12.8522C13.0511 15.0956 13.2122 15.2568 13.2122 15.4556V16.7596C13.2122 16.9585 13.0511 17.1196 12.8522 17.1196H11.5482C11.3494 17.1196 11.1882 16.9585 11.1882 16.7596V15.4556Z'
                fill='#333438'
            />
            <path
                d='M15.4122 11.5996C15.2134 11.5996 15.0522 11.7608 15.0522 11.9596V13.2636C15.0522 13.4624 15.2134 13.6236 15.4122 13.6236H16.7162C16.9151 13.6236 17.0762 13.4624 17.0762 13.2636V11.9596C17.0762 11.7608 16.9151 11.5996 16.7162 11.5996H15.4122Z'
                fill='#333438'
            />
            <path
                d='M15.0522 15.4556C15.0522 15.2568 15.2134 15.0956 15.4122 15.0956H16.7162C16.9151 15.0956 17.0762 15.2568 17.0762 15.4556V16.7596C17.0762 16.9585 16.9151 17.1196 16.7162 17.1196H15.4122C15.2134 17.1196 15.0522 16.9585 15.0522 16.7596V15.4556Z'
                fill='#333438'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M8.11111 2.59961C8.50876 2.59961 8.83111 2.92196 8.83111 3.31961V4.23956H15.5688V3.31961C15.5688 2.92196 15.8912 2.59961 16.2888 2.59961C16.6865 2.59961 17.0088 2.92196 17.0088 3.31961V4.23956H19.6C20.5941 4.23956 21.4 5.04545 21.4 6.03956V18.9996C21.4 19.9937 20.5941 20.7996 19.6 20.7996H4.8C3.80588 20.7996 3 19.9937 3 18.9996V6.03956C3 5.04545 3.80589 4.23956 4.8 4.23956H7.39111V3.31961C7.39111 2.92196 7.71347 2.59961 8.11111 2.59961ZM19.6 5.67956H4.8C4.60118 5.67956 4.44 5.84074 4.44 6.03956V8.32404H19.96V6.03956C19.96 5.84074 19.7988 5.67956 19.6 5.67956ZM19.96 9.76404H4.44V18.9996C4.44 19.1984 4.60118 19.3596 4.8 19.3596H19.6C19.7988 19.3596 19.96 19.1984 19.96 18.9996V9.76404Z'
                fill='#333438'
            />
            <path d='M4.8 5.67956H19.6C19.7988 5.67956 19.96 5.84074 19.96 6.03956V8.32404H4.44V6.03956C4.44 5.84074 4.60118 5.67956 4.8 5.67956Z' fill='#D5000D' />
            <path
                d='M7.32397 11.9596C7.32397 11.7608 7.48515 11.5996 7.68397 11.5996H8.98797C9.1868 11.5996 9.34797 11.7608 9.34797 11.9596V13.2636C9.34797 13.4624 9.1868 13.6236 8.98797 13.6236H7.68397C7.48515 13.6236 7.32397 13.4624 7.32397 13.2636V11.9596Z'
                fill='#D5000D'
            />
        </svg>
    );
};

export default IcCalendarRed;
